require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-forests-are-important-for-sustainable-developmentforest.json") })
        }
      }, "path---en-us-update-forests-are-important-for-sustainable-developmentforest");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-forests-are-important-for-sustainable-developmentforest!./.cache/json/en-us-update-forests-are-important-for-sustainable-developmentforest.json
// module id = 667
// module chunks = 231608221292675